import { ENVIRONMENT, SENTRY_DSN } from './config';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

export default {
  install(Vue, { enable = false }) {
    if (!enable) {
      return;
    }

    Sentry.init({
      dsn: SENTRY_DSN,
      integrations: [
        new Integrations.Vue({
          Vue,
          attachProps: true,
          logErrors: true,
        }),
      ],
      environment: ENVIRONMENT,
      tags: {
        locale: localStorage.getItem('language'),
      },
    });

    Vue.prototype.$sentry = Sentry;
  },
};

export { Sentry };
